import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import permissionTypes from '../components/atoms/permissionsGate/permissionTypes';
import routes from '../routes/route';

export default {

  attributeName: 'appTags',
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true, 
  createPath:routes.APP_TAGS_WHITE_LABEL_NEW,
  // canRemoveWhen:[{"field":"overriden","values":[1]}],
  editURL:routes.APP_TAGS_WHITE_LABEL_EDIT,
  permissionToCreate: [permissionTypes.APP_MANAGER_APP_CREATE],
  permissionToRemove: [permissionTypes.APP_MANAGER_APP_REMOVE],
  permissionToUpdate: [permissionTypes.APP_MANAGER_APP_UPDATE],
  emptyMessage: "You don’t have any tags yet. Click the “New” button above to create your first one.",
  fields: [
    // {
    //   attributeName: 'overriden',
    //   label: 'Custom',
    //   type: FormInputTypes.LINK,
    //   icon: IconType.EDIT,
    //   // width: '4rem',
    //   target:'_self',
    //   iconSize:'sm',
    //   iconColor:'#17a2b8',
    //   helpText: 'Overriden Tag.',
    //   hasClick:false,
    //   emptyValue:true,
    //   width: '5rem',

    // },   
    // {
    //   attributeName: 'typeTagAssignment',
    //   label: 'Assignment',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   helpText: 'The assignment of the master tag.',
    //   default: '',
    //   canEdit: false,
    //   canCreate: false,
    //   canFilter: true,
    //   canOrder: true,
    //   width: '8rem',

    // },
    // {
    //   attributeName: 'typeTagName',
    //   label: 'Category',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   helpText: 'The category of the master tag.',
    //   default: '',
    //   canEdit: false,
    //   canCreate: false,
    //   canFilter: true,
    //   canOrder: true,
    //   width: '8rem',

    // },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: true,
      helpText: 'Name of the tag.',
    },
    // {
    //   attributeName: 'visible',
    //   helpText: 'Visible',
    //   type: FormInputTypes.CHECKBOX,
    //   required: true,
    //   label: 'Visible',
    //   width: '5rem',

    // },    
    // {
    //   attributeName: 'score',
    //   helpText: 'Score of the tag',
    //   type: FormInputTypes.TEXT_INPUT.NUMBER,
    //   label: 'Score',
    //   placeholder: 'Score...',
    //   width: '5rem',

    // },
    // {
    //   attributeName: 'videoPreview',
    //   label: 'Video Preview',
    //   type: FormInputTypes.TAGS_PREVIEW,
    //   helpText: 'Tag preview in video',
      
    // },
    // {
    //   attributeName: 'extendedInfoPreview',
    //   label: 'Ex. Info Preview',
    //   type: FormInputTypes.TAGS_PREVIEW,
    //   helpText: 'Tag preview in extended info',
      
    // },
    // {
    //   attributeName: 'description',
    //   label: 'Description',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   helpText: 'The description of the master tag.',
    //   default: '',
    //   canEdit: false,
    //   canCreate: false,
    //   canFilter: false,
    //   canOrder: false,
    // },
 
    // {
    //   attributeName: 'description',
    //   label: 'Description',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   default: '',
    //   canOrder: false,
    //   canEdit: false,
    //   canCreate: false,
    //   canFilter: true,
    //   helpText: 'Description of the tag.',
    // },
  ],
};
